import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ModalidadSeleccionState } from './modalidad-seleccion.state';

export const selectModalidadSeleccionState =
  createFeatureSelector<ModalidadSeleccionState>('modalidadSeleccion');

export const selectAllModalidadesSeleccion = createSelector(
  selectModalidadSeleccionState,
  (state: ModalidadSeleccionState) => state.modalidadesSeleccion
);

export const selectSelectedModalidadSeleccion = createSelector(
  selectModalidadSeleccionState,
  (state: ModalidadSeleccionState) => state.selectedModalidadSeleccion
);

export const selectModalidadSeleccionLoading = createSelector(
  selectModalidadSeleccionState,
  (state: ModalidadSeleccionState) => state.loading
);

export const selectModalidadSeleccionError = createSelector(
  selectModalidadSeleccionState,
  (state: ModalidadSeleccionState) => state.error
);

export const selectModalidadSeleccionCreating = createSelector(
  selectModalidadSeleccionState,
  (state: ModalidadSeleccionState) => state.creating
);

export const selectModalidadSeleccionUpdating = createSelector(
  selectModalidadSeleccionState,
  (state: ModalidadSeleccionState) => state.updating
);

export const selectModalidadSeleccionDeleting = createSelector(
  selectModalidadSeleccionState,
  (state: ModalidadSeleccionState) => state.deleting
);

export const selectModalidadSeleccionSearchResults = createSelector(
  selectModalidadSeleccionState,
  (state: ModalidadSeleccionState) => state.searchResults
);

export const selectModalidadSeleccionSearchQuery = createSelector(
  selectModalidadSeleccionState,
  (state: ModalidadSeleccionState) => state.searchQuery
);

export const selectActiveModalidadesSeleccion = createSelector(
  selectAllModalidadesSeleccion,
  modalidadesSeleccion => modalidadesSeleccion.filter(ms => ms.estado)
);

export const selectInactiveModalidadesSeleccion = createSelector(
  selectAllModalidadesSeleccion,
  modalidadesSeleccion => modalidadesSeleccion.filter(ms => !ms.estado)
);

export const selectModalidadSeleccionById = (id: number) =>
  createSelector(selectAllModalidadesSeleccion, modalidadesSeleccion =>
    modalidadesSeleccion.find(ms => ms.modalidadSelId === id)
  );

export const selectModalidadesSeleccionToDisplay = createSelector(
  selectAllModalidadesSeleccion,
  selectModalidadSeleccionSearchResults,
  selectModalidadSeleccionSearchQuery,
  (allModalidades, searchResults, searchQuery) => {
    return searchQuery && searchQuery.trim() !== '' ? searchResults : allModalidades;
  }
);
